<template>
        <router-view v-if="sessionActive"></router-view>
</template>

<script>

    import activeSessionChecker from '../../../components/mixins/activeSessionCheckerMixin';

    export default {

        mixins: [activeSessionChecker],
    }

</script>
